import React, { useState, useEffect } from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

const LogDataChart = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [url, setUrl] = useState('https://mykns.ru/logs/fit4/fit4.25.07.22.17');

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const text = await response.text();
      
      // Parse the log data
      const parsedData = text.split('\n')
        .filter(line => line.trim() !== '')
        .map(line => {
          const [secondsOfHour, value] = line.split(' ');
          return {
            secondsOfHour: parseInt(secondsOfHour, 10),
            time: new Date(0, 0, 0, 0, 0, parseInt(secondsOfHour, 10)).toLocaleTimeString(),
            value: parseFloat(value)
          };
        });
      
      setData(parsedData);
    } catch (err) {
      setError(err.message);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [url]);

  const handleSubmit = (e) => {
    e.preventDefault();
    fetchData();
  };

  return (
    // <div className=>
    <div style={{ width: '100%', height: '500px' }}>
      <h2>Log Data Visualization</h2>
      
      <form onSubmit={handleSubmit} style={{ marginBottom: '20px' }}>
        <label>
          Log URL:
          <input
            type="text"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            style={{ width: '400px', margin: '0 10px' }}
          />
        </label>
        <button type="submit">Load Data</button>
      </form>
      
      {loading && <div>Loading data...</div>}
      {error && <div style={{ color: 'red' }}>Error: {error}</div>}
      
      {data.length > 0 && (
        <ResponsiveContainer width="100%" height="80%">
          <LineChart
            data={data}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis 
              dataKey="time" 
              label={{ value: 'Time', position: 'insideBottomRight', offset: -10 }} 
            />
            <YAxis 
              label={{ value: 'Value', angle: -90, position: 'insideLeft' }} 
            />
            <Tooltip />
            <Legend />
            <Line 
              type="monotone" 
              dataKey="value" 
              stroke="#8884d8" 
              activeDot={{ r: 8 }} 
              name="Value" 
            />
          </LineChart>
        </ResponsiveContainer>
      )}
      
      {!loading && data.length === 0 && !error && (
        <div>No data available</div>
      )}
    </div>
  );
};

export default LogDataChart;